import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef,BsModalService } from 'ngx-bootstrap/modal';
//import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-exportar-list',
  templateUrl: './exportar-list.component.html',
  styleUrls: ['./exportar-list.component.scss']
})

export class ExportarListComponent
  extends BaseFormComponent<any> implements OnInit   {
    
    modalPrintRef?: BsModalRef;
    @ViewChild('modalPPExport') modalPPExport: TemplateRef<any>;
    processList: any;
    process_id: any;
    type: any;

    constructor(
      //private myService: DocumentoTipoService,
      public activatedRoute: ActivatedRoute,
      private modalService: BsModalService,
      private fb: FormBuilder,
      private navigation: NavigationService,
    ) {
      super(activatedRoute);
    }
    
    ngOnInit() {
      this.processList = this.activatedRoute.snapshot.data["processos"];
      this.process_id = this.processList[0].id;
      this.loaded();
    }

   

    openPrintModal(e,type) {
      //this.modalPrintRef = this.modalService.show(this.modalPrint);
      e.preventDefault();
      this.modalPrintRef = this.modalService.show(this.modalPPExport);
      this.type = type;
    }

    closePrintModal() {
      this.modalPrintRef?.hide();
    }
    
    exportar(){
      let typeUrl = 'projetos';
      if (this.type) {
        if (this.type == 1) {
          typeUrl = 'projetos';
        } else if (this.type == 2) {
          typeUrl = 'caderno';
        } else if (this.type == 3) {
          typeUrl = 'produtos';
        }
      }
      const url = `${environment.apiUrl}/pre-projeto/exportar/${typeUrl}?type=${this.type}&process_id=${this.process_id}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    modificaId(e: any) {
      if (e) {
        console.log('Selected ID:', e.id);
        this.process_id = e.id;
      } else {
        this.process_id = this.processList[0].id;
      }
    }
   
}
